export const LayoutSpace = "16px";
export const HeaderHeight = "3rem";
export const LayoutMinWidth = "1300px";

export const localStorageKey = "Infer3D_Authorization";

export const defaultColor = "#9999997F";

export const prefixH5 = "vr";
